module.exports = "https://static.im-cdn.com/mjc/storefront/Florencia/static/media/Halfstar.05d6e188.svg";